import { render } from "./EditMeetingPoints.vue?vue&type=template&id=ae0b304c&scoped=true"
import script from "./EditMeetingPoints.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./EditMeetingPoints.vue?vue&type=script&charset=utf-8&lang=js"

import "./EditMeetingPoints.vue?vue&type=style&index=0&id=ae0b304c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae0b304c"]])

export default __exports__